import { SVGProps } from 'react';
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 334 334"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <mask
      id="mask0_714_4653"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={334}
      height={334}
    >
      <path
        d="M167 0.54183C258.932 0.54183 333.458 75.0678 333.458 167C333.458 258.933 258.932 333.458 167 333.458C75.0674 333.458 0.541504 258.933 0.541504 167C0.541504 75.0678 75.0674 0.54183 167 0.54183Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_714_4653)">
      <mask
        id="mask1_714_4653"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={-12}
        y={-12}
        width={358}
        height={358}
      >
        <path d="M-11.7886 345.788H345.788V-11.7879H-11.7886V345.788Z" fill="white" />
      </mask>
      <g mask="url(#mask1_714_4653)">
        <mask
          id="mask2_714_4653"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={-13}
          y={-13}
          width={360}
          height={359}
        >
          <path d="M-12.9233 345.921H346.924V-12.7399H-12.9233V345.921Z" fill="white" />
        </mask>
        <g mask="url(#mask2_714_4653)">
          <rect x={-12.936} y={-12.7788} width={359.871} height={358.735} fill="url(#pattern0)" />
        </g>
      </g>
    </g>
    <path
      d="M167 62.1931C138.536 62.1931 134.966 62.3138 123.788 62.8241C112.632 63.3329 105.014 65.1048 98.3467 67.6956C91.455 70.3739 85.6101 73.9576 79.7833 79.7841C73.9569 85.6109 70.3731 91.4557 67.6949 98.3475C65.104 105.014 63.3321 112.633 62.823 123.789C62.313 134.968 62.1924 138.536 62.1924 167C62.1924 195.464 62.313 199.033 62.823 210.212C63.3321 221.368 65.104 228.986 67.6949 235.653C70.3731 242.545 73.9569 248.39 79.7833 254.217C85.6101 260.043 91.455 263.627 98.3467 266.305C105.014 268.896 112.632 270.668 123.788 271.177C134.966 271.687 138.536 271.808 167 271.808C195.464 271.808 199.032 271.687 210.211 271.177C221.367 270.668 228.986 268.896 235.653 266.305C242.544 263.627 248.389 260.043 254.216 254.217C260.042 248.39 263.626 242.545 266.304 235.653C268.895 228.986 270.667 221.368 271.176 210.212C271.686 199.033 271.807 195.464 271.807 167C271.807 138.536 271.686 134.968 271.176 123.789C270.667 112.633 268.895 105.014 266.304 98.3475C263.626 91.4557 260.042 85.6109 254.216 79.7841C248.389 73.9576 242.544 70.3739 235.653 67.6956C228.986 65.1048 221.367 63.3329 210.211 62.8241C199.032 62.3138 195.464 62.1931 167 62.1931ZM167 81.0777C194.984 81.0777 198.299 81.1842 209.351 81.6883C219.569 82.1548 225.119 83.8621 228.812 85.2972C233.704 87.1983 237.195 89.4696 240.863 93.1375C244.53 96.8047 246.801 100.296 248.703 105.188C250.138 108.881 251.845 114.431 252.311 124.649C252.815 135.701 252.922 139.016 252.922 167C252.922 194.985 252.815 198.3 252.311 209.351C251.845 219.57 250.138 225.119 248.703 228.812C246.801 233.705 244.53 237.196 240.863 240.863C237.195 244.531 233.704 246.802 228.812 248.704C225.119 250.139 219.569 251.846 209.351 252.312C198.301 252.816 194.986 252.923 167 252.923C139.013 252.923 135.699 252.816 124.649 252.312C114.43 251.846 108.881 250.139 105.187 248.704C100.295 246.802 96.804 244.531 93.1368 240.863C89.4692 237.196 87.1976 233.705 85.2964 228.812C83.8609 225.119 82.1541 219.57 81.6876 209.352C81.1835 198.3 81.077 194.985 81.077 167C81.077 139.016 81.1835 135.701 81.6876 124.649C82.1541 114.431 83.8609 108.881 85.2964 105.188C87.1976 100.296 89.4688 96.8047 93.1368 93.1375C96.804 89.4696 100.295 87.1983 105.187 85.2972C108.881 83.8621 114.43 82.1548 124.648 81.6883C135.7 81.1842 139.015 81.0777 167 81.0777Z"
      fill="white"
    />
    <path
      d="M167 201.936C147.706 201.936 132.064 186.294 132.064 167C132.064 147.706 147.706 132.064 167 132.064C186.295 132.064 201.935 147.706 201.935 167C201.935 186.294 186.295 201.936 167 201.936ZM167 113.18C137.276 113.18 113.18 137.276 113.18 167C113.18 196.724 137.276 220.82 167 220.82C196.724 220.82 220.82 196.724 220.82 167C220.82 137.276 196.724 113.18 167 113.18Z"
      fill="white"
    />
    <path
      d="M235.523 111.054C235.523 118 229.892 123.631 222.946 123.631C216 123.631 210.369 118 210.369 111.054C210.369 104.108 216 98.4769 222.946 98.4769C229.892 98.4769 235.523 104.108 235.523 111.054Z"
      fill="white"
    />
    <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width={1} height={1}>
        <use xlinkHref="#image0_714_4653" transform="scale(0.00328947 0.00330033)" />
      </pattern>
      <image
        id="image0_714_4653"
        width={304}
        height={303}
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAABU1BMVEX////aKn5jScyeKquULrDRJobcKnj92XXgMHK3I5rGI4/BI5T+//3pQlrWJH9aT9BQVNXkN2frS2SvJKGkJqfnPHPIFo+GNbdtQ8bnP2jLIoufIKP90G+8F5bQGYmuGp6LMrR5PMDvYEL0dlnp3O/7r1mOKqnsUEzzcTnxZ1bCGJGrKKR1O7puQb/UHoS2F5l+Obx+NrSnHaD07vX8u13uS3GYJafvXVzvWGb6pUn4j1f8wGj99ueFMa7tU1f2gzf7l2r3lT35h2nhNHv7qGv4dGv6oVv13+rzdkv9yGb4mlL7yHRkRcT2hkfqcIr1Z2j65tT3uKP2h1XEmtP83Yr0YHD75K/eRYbWSputbcL9tmylT7SMZMj6yIvziYRiXNDrkrRucdrXd7rkrta/SKuIedP2xMD66+abneHPi8rJMZqJT7nHueOvruadjtRtXsm/v+pdDOJHAAACO0lEQVQ4y2XT6XfhUBzG8StUqWBqCSqxFB2qWkaHErVvpdQyamktRavtrP//q/nde2OZzufkTc7zlRPn5CIkYdnon9en6XT6+/nXjyiL/uN9ffoE9Hrm9jb02PXCT3ZWNvqTzNIeOjv73o3+8/NnPZ31DEP2SOR66N3ZHxlGryczY7XS/frkQSpY2ENWhiJzmOwnmyI6jLjdISvhdrtht7jwHosN6Xt0XS5LOOzGwsBicbkUeLbb7V3yAg8KhQIaygXgPkb2L0H8b99MJrlcrtiCu5gJz+CNRZWlMRg0mUhF4RsTXp1O57KCFmrMaAzCRRgxp0S9QHMNUGvUuy7gIoSLORocHWxoKEEjCGqBWqLB3sYRQdJTShDeUV8mK8jWdLptyXHcKcdpUL9AqCglgEx3fu5wcNgB6pslNtshRisZSSB6R03zV8wAtNihFkdKJX2KY4BmeL4C8XT6MyARTmQkmaOXXq93BwLgGJDGtn7I3gKtJncl4PF4qlW/30+StBZeSIXfZFBBbLtUyoNkstPIZPykSacNNptZVVAqZ/Dlrib5LCiXa7VcLgNN9TgQTxsMUKj6FfzJvWSzReDz+RKJHDSNajUQj+PCPCNfVKpdHI1GoiheXkKSyDUaVU8gfgVFU/r0V+ORWK/zPH9zg5NasuMhRbOyPjatcZ3fB5DAU8pS0WxtD0bq2z61U0wqu0crdU8TeIbo85WTnXw7+uHwSgnPi/CIYrv18XyzLJtqQcPz9fr4frWd/wKtDIGLfUg5cQAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
);
export default SvgInstagram;
